// extracted by mini-css-extract-plugin
export default {"memoriesSection":"Memories_memoriesSection__2Jdpd","cardHeader":"Memories_cardHeader__ETyR4","memoriesContent":"Memories_memoriesContent__Jh2BT"};